<template>
    <VoMenyy>
      <template #elemendid>
        <template v-for="item in juurdepaasPoleLubatudMenuu()" :key="item.url">
          <VoMenyyElement :pealkiri="item.pealkiri" :url="item.url" :ikoon="item.ikoon" active-class="list-item-active" />
        </template>
      </template>
      <template #kasutaja>
        <KasutajaInfo></KasutajaInfo>
      </template>
    </VoMenyy>
    <v-main style="min-height: 1000px;">
        <v-container fluid>
            <v-row>
                <v-col cols="24">
                    <v-row>
                        <v-col>
                            <slot name="title">                                    
                            </slot>
                        </v-col>
                    </v-row>
                    <slot name="body"></slot>
                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import KasutajaInfo from "./KasutajaInfo.vue"
import { AuthTeenus } from '@/core/auth-teenus';
import juurdepaasPoleLubatudMenuu from "@/data/juurdepaasPoleLubatudMenuu";

const _authTeenus = new AuthTeenus();

export default defineComponent({
    name: 'KRHPTyhiPaigutus',
    data() {
        return {
            authService: _authTeenus,
            show: false,
        }
    },
    methods: {
      juurdepaasPoleLubatudMenuu() {
        return juurdepaasPoleLubatudMenuu
      }
    },
    components: { KasutajaInfo }
});
</script>
